import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';

// import {MalihuScrollbarService} from 'ngx-malihu-scrollbar';

@Directive({
    selector: '[dbCustomScrollbar]',
    standalone: false
})
export class CustomScrollbarDirective implements  AfterViewInit, OnDestroy {

  @Input() scrollTop: number;
  @Input() totalScrollEvent: boolean = false;
  @Input() disableScrollbar: boolean = false;
  @Output() totalScroll: EventEmitter<any>;

  constructor(
    private _ngZone: NgZone,
    private _elementRef: ElementRef,
    // private _malihuScrollbarService: MalihuScrollbarService
  ) {
    this.totalScroll = new EventEmitter<any>();
  }

  ngAfterViewInit() {
    /*SERINE if is uncommented, but in upgrade page sometimes width is grater thant 768 I think because of swipe section width*/
    if (window.innerWidth > 768) {
      //TODO: add ngx-malihu-scrollbar
      // setTimeout((): void => {
      //   if (this.totalScrollEvent) {
      //     this._elementRef.nativeElement && this._malihuScrollbarService.initScrollbar(this._elementRef.nativeElement, Object.assign(Config.malihuScrollbarDefaultOptions, {
      //       callbacks: {
      //         onTotalScroll: () => {
      //           this._ngZone.run(() => {
      //             this.totalScroll.emit();
      //           });
      //         }
      //       }
      //     }));
      //   }
      //   else {
      //     this._elementRef.nativeElement && this._malihuScrollbarService.initScrollbar(this._elementRef.nativeElement, Config.malihuScrollbarDefaultOptions);
      //   }
      // }, 100);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['scrollTop'] && (this.scrollTop || this.scrollTop === 0)) {
      try {
        // this._malihuScrollbarService.scrollTo(this._elementRef.nativeElement, this.scrollTop, {});
      }
      catch (e) {
      }
    }
  }

  ngOnDestroy() {
    try {
      // this._malihuScrollbarService.destroy(this._elementRef.nativeElement);
    }
    catch (e) {}
  }

  scrollTo(scrollTop: number): void {
    // this._malihuScrollbarService.scrollTo(this._elementRef.nativeElement, scrollTop, {scrollEasing: 'linear'});
  }

}
